module.exports = __webpack_public_path__ + "img/login.5f2298ae.webp";